fragment flexiblePostsSliderByTags on flexibleSections_postsSliderByTags_BlockType {
    __typename
    title: plaintext
    description: richTextMinimal
    tags {
        id
    }
}
